import { useEffect } from 'react'
import { DDG_MESSAGE_SOURCE, DdgHeightMessage } from '../embed/protocol'

// Reports content height to the parent window whenever the app is running
// inside the embed iframe, so the loader script can auto-size an inline embed.
export function useIframeResize() {
	useEffect(() => {
		if (typeof window === 'undefined' || window.self === window.top) return

		const target = document.body
		let lastHeight = 0

		const postHeight = () => {
			const height = target.scrollHeight
			if (height === lastHeight) return
			lastHeight = height
			const message: DdgHeightMessage = {
				source: DDG_MESSAGE_SOURCE,
				type: 'height',
				value: height,
			}
			window.parent.postMessage(message, '*')
		}

		const observer = new ResizeObserver(postHeight)
		observer.observe(target)
		postHeight()

		return () => observer.disconnect()
	}, [])
}
